
export const imageHandler = {
  property: 'data-background-image',
  load: (card) => {
    const elem = document.createElement('div')

    const backgroundImage = card.getAttribute('data-background-image')
    elem.setAttribute('style', `background-image: url(${backgroundImage}); background-size: cover; background-position-x: center;`)
    elem.id = card.getAttribute('data-background-id')

    return elem
  }
}



// WEBPACK FOOTER //
// ./src/client/sections/image/index.js